module.exports = __webpack_public_path__ + "static/Larsseit-Light-dfe2809d7ad4a31350159d990b85ad5a.otf";